import ProjectedHarvest from './ProjectedHarvest'

export default ProjectedHarvest
